var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"the-head"}},[_c('TheBreadcrumb',{staticClass:"the-breadcrumb"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }